import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  AuthenticationGuardService,
  CurrentUserService,
  HttpClientService,
  UiNotificationService,
  HttpErrorHandlerService,
  HttpAuthenticationService,
  HttpNoContentHandlerService,
} from './';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    AuthenticationGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthenticationService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpNoContentHandlerService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorHandlerService, multi: true },
    { provide: 'IHttpClientService', useClass: HttpClientService },
    { provide: 'IUiNotificationService', useClass: UiNotificationService },
    { provide: 'ICurrentUser', useClass: CurrentUserService },
  ]
})
export class ServicesModule { }
